import { createCustomError } from '@lib/errors';
import { i18n } from '@lib/i18n';

import type { RegionEntity, LocationEntity } from '@modules/shared/entities';
import type { SchoolType, SchoolArgs } from '@modules/types/graphql';

export type CreateSchoolFormValues = {
    region: RegionEntity | null;
    location: LocationEntity | null;
    type: SchoolType | string | null;
    shortName: string;
    number: string;
    email: string;
};

class CreateSchoolRequest {
    locationId: SchoolArgs['locationId'];
    type: SchoolArgs['type'];
    shortName: SchoolArgs['shortName'];
    number: SchoolArgs['number'];
    email: SchoolArgs['email'];

    constructor(values: CreateSchoolFormValues) {
        if (!values.location) {
            throw createCustomError(i18n.t('errors:location.invalid'));
        }

        if (!values.type || typeof values.type !== 'string') {
            throw createCustomError(i18n.t('errors:school.invalid_school_type'));
        }

        this.locationId = values.location.id;
        this.type = values.type as SchoolType;
        this.shortName = values.shortName;
        this.number = values.number ? parseInt(values.number, 10) : null;
        this.email = values.email;
    }
}

export { CreateSchoolRequest };
